import { render, staticRenderFns } from "./ContactDependents.vue?vue&type=template&id=29afd689"
import script from "./ContactDependents.vue?vue&type=script&lang=js"
export * from "./ContactDependents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports